export default __webpack_public_path__ + "images/a1cd8f6b85d65ff94633d85b62ff71dd-scurve.svg";